import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import * as numbers from "common/numbers";
import DefaultLoader from "components/common/DefaultLoader";
import { useSelector } from "react-redux";
import * as exposureSelectors from "store/selectors/input/exposure/exposureSelectors";
import * as programSelectors from "store/selectors/input/program/programSelectors";

const RecentExposures = ({ maxYears = 10 }) => {
  const exposureListUpdating = useSelector(
    exposureSelectors.isExposureListUpdating
  );
  const inceptionYear = useSelector(programSelectors.getInceptionYear);
  const years = useSelector(exposureSelectors.getExposuresYears);
  const exposuresUsed = useSelector(exposureSelectors.getExposuresUsed);
  const data = useSelector(exposureSelectors.getData);

  const projectedYear = ((inceptionYear ?? 0) + 1).toString();
  const hasProjectedData =
    Object.keys(data).includes(projectedYear) &&
    Object.values(data?.[projectedYear] ?? {}).some((x) => x != null);
  const offset = hasProjectedData ? 0 : 1;
  const yearsToDisplay = years.slice(
    offset,
    (maxYears ?? years.length - offset) + offset
  );

  const exposures = (exposuresUsed ?? [])
    .map((exposure) => ({
      key: exposure.key,
      label: exposure.name,
      data: yearsToDisplay.map((year) => data?.[year]?.[exposure.key] ?? null),
    }))
    .filter(
      (exposure) =>
        exposure.data.filter((x) => x != null).length >=
        Math.floor(maxYears / 2)
    );

  const numberFormatter = numbers.dpString(0);

  return exposureListUpdating ? (
    <DefaultLoader
      style={{
        width: "200px",
        height: "200px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: "auto",
        marginRight: "auto",
      }}
      size={60}
    />
  ) : (
    <TableContainer>
      <Table
        className={"exposure-inputs fluid-width print-table-micro"}
        size={"small"}
      >
        <TableHead>
          <TableRow>
            <TableCell className={"name-column"}>{"Measure"}</TableCell>
            {yearsToDisplay?.map((year) => (
              <TableCell align={"right"} key={year}>
                {year > inceptionYear ? "Projected" : year.toString()}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {exposures.map((exposure) => (
            <TableRow key={exposure.key}>
              <TableCell className={"name-column"} scope={"row"}>
                {exposure.label}
              </TableCell>
              {exposure.data.map((value, index) => (
                <TableCell key={index} align={"right"}>
                  {numberFormatter(value)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RecentExposures;
